import { useState, useEffect } from "react";
import axios from "axios";

const REASON_LABELS = {
  vacation: { label: "Отпуск", color: "#00d2b4", bg: "rgba(0,210,180,0.1)" },
  sick: { label: "Больничный", color: "#f59e0b", bg: "rgba(245,158,11,0.1)" },
  day_off: { label: "Выходной", color: "#8892a4", bg: "rgba(136,146,164,0.1)" },
};

const ROLE_LABELS = {
  reporter: { label: "Сдаёт отчёт", color: "#00d2b4" },
  manager: { label: "Менеджер", color: "#818cf8" },
  excluded: { label: "Исключён", color: "#8892a4" },
};

const TYPE_LABELS = {
  twice: "2 раза в день",
  once: "1 раз в день",
};

export default function Employees() {
  const [employees, setEmployees] = useState([]);
  const [vacations, setVacations] = useState([]);
  const [activeVacations, setActiveVacations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("employees");
  const [showVacForm, setShowVacForm] = useState(false);
  const [vacForm, setVacForm] = useState({
    employee_bitrix_id: "",
    employee_name: "",
    date_from: "",
    date_to: "",
    reason: "vacation",
  });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const [empRes, vacRes, activeRes] = await Promise.all([
        axios.get("/api/employees/"),
        axios.get("/api/vacations/"),
        axios.get("/api/vacations/active"),
      ]);
      setEmployees(empRes.data);
      setVacations(vacRes.data);
      setActiveVacations(activeRes.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const deactivate = async (bitrix_id, name) => {
    if (!window.confirm(`Деактивировать ${name}?`)) return;
    await axios.delete(`/api/employees/${bitrix_id}`);
    load();
  };

  const changeRole = async (bitrix_id, role) => {
    await axios.patch(`/api/employees/${bitrix_id}`, { role });
    load();
  };

  const changeType = async (bitrix_id, report_type) => {
    await axios.patch(`/api/employees/${bitrix_id}`, { report_type });
    load();
  };

  const addVacation = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.post("/api/vacations/", vacForm);
      setShowVacForm(false);
      setVacForm({ employee_bitrix_id: "", employee_name: "", date_from: "", date_to: "", reason: "vacation" });
      load();
    } finally {
      setSaving(false);
    }
  };

  const deleteVacation = async (id) => {
    if (!window.confirm("Удалить запись?")) return;
    await axios.delete(`/api/vacations/${id}`);
    load();
  };

  const reporters = employees.filter(e => e.role === "reporter");
  const activeIds = new Set(activeVacations.map(v => v.employee_bitrix_id));

  return (
    <div style={{ fontFamily: "Inter, sans-serif", color: "#fff" }}>
      <div style={{ marginBottom: 28 }}>
        <div style={{ fontSize: 24, fontWeight: 600, color: "#fff", marginBottom: 4 }}>Сотрудники</div>
        <div style={{ fontSize: 14, color: "#8892a4" }}>Управление списком, ролями, отпусками и больничными</div>
      </div>

      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        {[
          { id: "employees", label: `Сотрудники (${employees.filter(e => e.is_active).length})` },
          { id: "vacations", label: `Отпуска/Больничные (${activeVacations.length} активных)` },
        ].map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            padding: "8px 20px", borderRadius: 6, border: "0.5px solid",
            borderColor: tab === t.id ? "#00d2b4" : "rgba(255,255,255,0.1)",
            background: tab === t.id ? "rgba(0,210,180,0.1)" : "transparent",
            color: tab === t.id ? "#00d2b4" : "#8892a4",
            fontSize: 13, fontWeight: 500, cursor: "pointer",
          }}>{t.label}</button>
        ))}
      </div>

      {loading ? (
        <div style={{ color: "#8892a4", padding: 40, textAlign: "center" }}>Загрузка...</div>
      ) : tab === "employees" ? (
        <div style={{ background: "#011d1c", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "0.5px solid rgba(0,210,180,0.15)" }}>
                {["ID", "Имя", "Должность", "Роль", "График", "Статус", ""].map(h => (
                  <th key={h} style={{ padding: "12px 16px", fontSize: 11, fontWeight: 600, color: "#8892a4", textAlign: "left", letterSpacing: "0.08em", textTransform: "uppercase" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {employees.map(emp => {
                const isOnVacation = activeIds.has(emp.bitrix_id);
                const vacInfo = activeVacations.find(v => v.employee_bitrix_id === emp.bitrix_id);
                return (
                  <tr key={emp.id} style={{ borderBottom: "0.5px solid rgba(255,255,255,0.04)", opacity: emp.is_active ? 1 : 0.4 }}>
                    <td style={{ padding: "12px 16px", fontSize: 12, color: "#8892a4" }}>{emp.bitrix_id}</td>
                    <td style={{ padding: "12px 16px" }}>
                      <div style={{ fontSize: 14, fontWeight: 500, color: "#fff" }}>{emp.name}</div>
                      {isOnVacation && vacInfo && (
                        <div style={{ fontSize: 11, color: REASON_LABELS[vacInfo.reason]?.color || "#f59e0b", marginTop: 2 }}>
                          {REASON_LABELS[vacInfo.reason]?.label} до {vacInfo.date_to}
                        </div>
                      )}
                    </td>
                    <td style={{ padding: "12px 16px", fontSize: 13, color: "#8892a4" }}>{emp.position || "—"}</td>
                    <td style={{ padding: "12px 16px" }}>
                      {emp.is_active ? (
                        <select value={emp.role} onChange={e => changeRole(emp.bitrix_id, e.target.value)}
                          style={{ background: "#003734", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 4, color: ROLE_LABELS[emp.role]?.color || "#fff", fontSize: 12, padding: "4px 8px", cursor: "pointer" }}>
                          <option value="reporter">Сдаёт отчёт</option>
                          <option value="manager">Менеджер</option>
                          <option value="excluded">Исключён</option>
                        </select>
                      ) : <span style={{ fontSize: 12, color: "#8892a4" }}>—</span>}
                    </td>
                    <td style={{ padding: "12px 16px" }}>
                      {emp.role === "reporter" && emp.is_active ? (
                        <select value={emp.report_type || "twice"} onChange={e => changeType(emp.bitrix_id, e.target.value)}
                          style={{ background: "#003734", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 4, color: "#bbc7c6", fontSize: 12, padding: "4px 8px", cursor: "pointer" }}>
                          <option value="twice">2 раза в день</option>
                          <option value="once">1 раз в день</option>
                        </select>
                      ) : <span style={{ fontSize: 12, color: "#8892a4" }}>—</span>}
                    </td>
                    <td style={{ padding: "12px 16px" }}>
                      <span style={{
                        fontSize: 11, fontWeight: 600, padding: "3px 8px", borderRadius: 4,
                        background: emp.is_active ? "rgba(0,210,180,0.1)" : "rgba(255,107,107,0.1)",
                        color: emp.is_active ? "#00d2b4" : "#ff6b6b",
                        border: `0.5px solid ${emp.is_active ? "rgba(0,210,180,0.2)" : "rgba(255,107,107,0.2)"}`,
                      }}>
                        {emp.is_active ? (isOnVacation ? "В отпуске" : "Активен") : "Неактивен"}
                      </span>
                    </td>
                    <td style={{ padding: "12px 16px" }}>
                      <div style={{ display: "flex", gap: 8 }}>
                        {emp.is_active && emp.role === "reporter" && (
                          <button onClick={() => {
                            setVacForm({ ...vacForm, employee_bitrix_id: emp.bitrix_id, employee_name: emp.name });
                            setTab("vacations");
                            setShowVacForm(true);
                          }} style={{ fontSize: 11, padding: "4px 10px", background: "rgba(0,210,180,0.1)", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 4, color: "#00d2b4", cursor: "pointer" }}>
                            + Отпуск
                          </button>
                        )}
                        {emp.is_active && (
                          <button onClick={() => deactivate(emp.bitrix_id, emp.name)}
                            style={{ fontSize: 11, padding: "4px 10px", background: "rgba(255,107,107,0.1)", border: "0.5px solid rgba(255,107,107,0.2)", borderRadius: 4, color: "#ff6b6b", cursor: "pointer" }}>
                            Деактивировать
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <div style={{ fontSize: 14, color: "#8892a4" }}>
              Сотрудники отмеченные как в отпуске/больничном не проверяются агентом
            </div>
            <button onClick={() => setShowVacForm(!showVacForm)} style={{
              padding: "8px 20px", background: "linear-gradient(90deg, #00d2b4, #cbfffc)",
              border: "none", borderRadius: 6, color: "#011d1c", fontSize: 13, fontWeight: 600, cursor: "pointer",
            }}>+ Добавить запись</button>
          </div>

          {showVacForm && (
            <form onSubmit={addVacation} style={{ background: "#011d1c", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 12, padding: 24, marginBottom: 20 }}>
              <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 20, color: "#fff" }}>Новая запись об отсутствии</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 16, marginBottom: 16 }}>
                <div>
                  <div style={{ fontSize: 11, color: "#8892a4", marginBottom: 6, letterSpacing: "0.1em", textTransform: "uppercase" }}>Сотрудник</div>
                  <select value={vacForm.employee_bitrix_id} onChange={e => {
                    const emp = reporters.find(r => r.bitrix_id === parseInt(e.target.value));
                    setVacForm({ ...vacForm, employee_bitrix_id: parseInt(e.target.value), employee_name: emp?.name || "" });
                  }} required style={{ width: "100%", background: "#003734", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 6, color: "#fff", fontSize: 13, padding: "10px 12px" }}>
                    <option value="">Выбрать...</option>
                    {reporters.filter(e => e.is_active).map(e => (
                      <option key={e.id} value={e.bitrix_id}>{e.name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <div style={{ fontSize: 11, color: "#8892a4", marginBottom: 6, letterSpacing: "0.1em", textTransform: "uppercase" }}>Тип</div>
                  <select value={vacForm.reason} onChange={e => setVacForm({ ...vacForm, reason: e.target.value })}
                    style={{ width: "100%", background: "#003734", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 6, color: "#fff", fontSize: 13, padding: "10px 12px" }}>
                    <option value="vacation">Отпуск</option>
                    <option value="sick">Больничный</option>
                    <option value="day_off">Выходной</option>
                  </select>
                </div>
                <div>
                  <div style={{ fontSize: 11, color: "#8892a4", marginBottom: 6, letterSpacing: "0.1em", textTransform: "uppercase" }}>С даты</div>
                  <input type="date" value={vacForm.date_from} onChange={e => setVacForm({ ...vacForm, date_from: e.target.value })} required
                    style={{ width: "100%", background: "#003734", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 6, color: "#fff", fontSize: 13, padding: "10px 12px" }} />
                </div>
                <div>
                  <div style={{ fontSize: 11, color: "#8892a4", marginBottom: 6, letterSpacing: "0.1em", textTransform: "uppercase" }}>По дату</div>
                  <input type="date" value={vacForm.date_to} onChange={e => setVacForm({ ...vacForm, date_to: e.target.value })} required
                    style={{ width: "100%", background: "#003734", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 6, color: "#fff", fontSize: 13, padding: "10px 12px" }} />
                </div>
              </div>
              <div style={{ display: "flex", gap: 12 }}>
                <button type="submit" disabled={saving} style={{ padding: "10px 24px", background: "linear-gradient(90deg, #00d2b4, #cbfffc)", border: "none", borderRadius: 6, color: "#011d1c", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
                  {saving ? "Сохранение..." : "Сохранить"}
                </button>
                <button type="button" onClick={() => setShowVacForm(false)} style={{ padding: "10px 24px", background: "transparent", border: "0.5px solid rgba(255,255,255,0.1)", borderRadius: 6, color: "#8892a4", fontSize: 13, cursor: "pointer" }}>
                  Отмена
                </button>
              </div>
            </form>
          )}

          <div style={{ background: "#011d1c", border: "0.5px solid rgba(0,210,180,0.2)", borderRadius: 12, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ borderBottom: "0.5px solid rgba(0,210,180,0.15)" }}>
                  {["Сотрудник", "Тип", "С даты", "По дату", "Статус", ""].map(h => (
                    <th key={h} style={{ padding: "12px 16px", fontSize: 11, fontWeight: 600, color: "#8892a4", textAlign: "left", letterSpacing: "0.08em", textTransform: "uppercase" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {vacations.length === 0 ? (
                  <tr><td colSpan={6} style={{ padding: 40, textAlign: "center", color: "#8892a4", fontSize: 14 }}>Записей нет</td></tr>
                ) : vacations.map(v => {
                  const today = new Date().toISOString().split("T")[0];
                  const isActive = v.date_from <= today && v.date_to >= today;
                  const r = REASON_LABELS[v.reason] || REASON_LABELS.day_off;
                  return (
                    <tr key={v.id} style={{ borderBottom: "0.5px solid rgba(255,255,255,0.04)" }}>
                      <td style={{ padding: "12px 16px", fontSize: 14, fontWeight: 500, color: "#fff" }}>{v.employee_name}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{ fontSize: 12, padding: "3px 8px", borderRadius: 4, background: r.bg, color: r.color, border: `0.5px solid ${r.color}40` }}>{r.label}</span>
                      </td>
                      <td style={{ padding: "12px 16px", fontSize: 13, color: "#bbc7c6" }}>{v.date_from}</td>
                      <td style={{ padding: "12px 16px", fontSize: 13, color: "#bbc7c6" }}>{v.date_to}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{ fontSize: 11, padding: "3px 8px", borderRadius: 4, background: isActive ? "rgba(0,210,180,0.1)" : "rgba(112,119,119,0.1)", color: isActive ? "#00d2b4" : "#707777", border: `0.5px solid ${isActive ? "rgba(0,210,180,0.2)" : "rgba(112,119,119,0.2)"}` }}>
                          {isActive ? "Активен" : "Завершён"}
                        </span>
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        <button onClick={() => deleteVacation(v.id)} style={{ fontSize: 11, padding: "4px 10px", background: "rgba(255,107,107,0.1)", border: "0.5px solid rgba(255,107,107,0.2)", borderRadius: 4, color: "#ff6b6b", cursor: "pointer" }}>
                          Удалить
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
